import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useGetCurrentCommunity from '../../hooks/useGetCurrentCommunity';
import { fetchBanners } from '../../store/banners';
import { RootState, AppDispatch } from '../../store';
import DynamicBanner from './DynamicBanner';

export const Banners = () => {
  const dispatch = useDispatch<AppDispatch>();
  const communityCheck = useGetCurrentCommunity();
  const { community } = communityCheck;

  const { banners, loading, error } = useSelector(
    (state: RootState) => state.banners,
  );

  const userPlatform = useSelector((state: RootState) => state.user.platform);

  const [closedBanners, setClosedBanners] = useState<Set<string>>(new Set());
  useEffect(() => {
    dispatch(fetchBanners('command-center'));
  }, [dispatch]);

  const activeBanners = banners.filter(
    (banner) =>
      !closedBanners.has(banner.id) &&
      (!banner.plateform || banner.plateform === userPlatform),
  );

  const handleCloseBanner = (bannerId: string) => {
    setClosedBanners((prev) => new Set(prev).add(bannerId));
  };

  if (loading || !community) {
    return null;
  }

  if (error) {
    console.error('Failed to load banners:', error);
  }

  return (
    <>
      {activeBanners.map((banner) => (
        <DynamicBanner
          key={banner.id}
          communityId={community.communityId}
          banner={banner}
          onClose={() => handleCloseBanner(banner.id)}
        />
      ))}
    </>
  );
};
